import React, { createContext, useCallback, useMemo, useState } from 'react';
import { PTDialogAppComponent } from '../components/ui';

export const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState({});
  const [onConfirm, setOnConfirm] = useState(null);
  const [onCancel, setOnCancel] = useState(null);

  const showDialog = useCallback((content, confirmCb, cancelCb) => {
    setDialogContent(content);
    setOnConfirm(() => confirmCb);
    setOnCancel(() => cancelCb);
    setOpen(true);
  }, []);

  const hideDialog = useCallback(() => {
    setOpen(false);
    setDialogContent({});
    setOnConfirm(null);
    setOnCancel(null);
  }, []);

  const contextValue = useMemo(() => ({
    showDialog,
    hideDialog
  }), [showDialog, hideDialog]);

  const memoizedChildren = useMemo(() => children, [children]);

  return (
    <DialogContext.Provider value={contextValue}>
      {memoizedChildren}
      <PTDialogAppComponent
        open={open}
        content={dialogContent}
        onConfirm={onConfirm}
        onCancel={onCancel}
        onClose={hideDialog}
        data={dialogContent.data}
      />
    </DialogContext.Provider>
  );
};

export default DialogProvider;